import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { format } from "date-fns";
import React from "react";

import { ShiftType } from "../../../../store/gat-admin-slice-types";
import { Schedule } from "../../types";

interface MenuProps {
	handleMenuItemClick: (id: null | number, colorCode: undefined | string) => void;
	allShiftSchedules: ShiftType[];
  shiftPatternArray: Schedule[];
	open: boolean;
	anchorEl: null | HTMLElement;
	handleClose: () => void;
	selectedShiftTypeId: null | number;
  selectedDay: number;
}

const ShiftScheduleMenuList: React.FC<MenuProps> = ({
	handleMenuItemClick,
	allShiftSchedules,
  shiftPatternArray,
	open,
	anchorEl,
	handleClose,
	selectedShiftTypeId,
  selectedDay,
}) => {
  const getNonOverlappingShifts = (targetDayNo: number): ShiftType[] => {
    const DAY_IN_MS = 24 * 60 * 60 * 1000;
    const patternLength = shiftPatternArray.length;
    if (patternLength === 0) return allShiftSchedules;

    return allShiftSchedules.filter((shiftSchedule: ShiftType) => {
      const isOverlapping = shiftPatternArray.some((schedule: Schedule) => {
        // When checking for overlaps, completely ignore any shifts on the day we are editing.
        // This allows us to see all valid shift options for the target day.
        if (schedule.dayNo === targetDayNo) {
          return false;
        }

        const referenceShift = allShiftSchedules.find(
          (s: ShiftType) => s.id === schedule.shiftTypeId
        );

        if (!referenceShift) return false;

        const currentStart = new Date(`2024-01-01T${shiftSchedule.startTime}`).getTime();
        let currentEnd = new Date(`2024-01-01T${shiftSchedule.endTime}`).getTime();
        if (currentEnd <= currentStart) {
          currentEnd += DAY_IN_MS;
        }

        let dayOffset = schedule.dayNo - targetDayNo;
        if (dayOffset > patternLength / 2) {
          dayOffset -= patternLength;
        } else if (dayOffset < -patternLength / 2) {
          dayOffset += patternLength;
        }

        const referenceStart_time_only = new Date(`2024-01-01T${referenceShift.startTime}`).getTime();
        let referenceEnd_time_only = new Date(`2024-01-01T${referenceShift.endTime}`).getTime();

        if (referenceEnd_time_only <= referenceStart_time_only) {
          referenceEnd_time_only += DAY_IN_MS;
        }

        const referenceStart = referenceStart_time_only + dayOffset * DAY_IN_MS;
        const referenceEnd = referenceEnd_time_only + dayOffset * DAY_IN_MS;

        return currentStart < referenceEnd && currentEnd > referenceStart;
      });

      return !isOverlapping;
    });
  };

  if (getNonOverlappingShifts(selectedDay)?.length === 0) {
    return (
      <Menu
        id='shift-schedule-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem disabled>No available shift schedules</MenuItem>
      </Menu>
    );
  }
	return (
		<div>
			<Menu
				id='shift-schedule-menu'
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
			>
				<MenuItem
					selected={selectedShiftTypeId === null}
					onClick={() => {
						handleMenuItemClick(null, undefined);
						handleClose();
					}}
				>
					Off
				</MenuItem>
				{getNonOverlappingShifts(selectedDay)?.map((shiftSchedule: ShiftType) => {
					return (
						<MenuItem
							key={`shift-schedule-menu-item-${shiftSchedule.id}`}
							id={`shift-schedule-${shiftSchedule.id}`}
							selected={shiftSchedule.id === selectedShiftTypeId}
							onClick={() => {
								handleMenuItemClick(shiftSchedule.id, shiftSchedule.colorCode);
								handleClose();
							}}
						>
							{`${shiftSchedule.name} (${format(
								new Date(`2024-01-01T${shiftSchedule.startTime}`),
								"hh:mm a"
							).toUpperCase()} - ${format(
								new Date(`2024-01-01T${shiftSchedule.endTime}`),
								"hh:mm a"
							).toUpperCase()})`}
						</MenuItem>
					);
				})}
			</Menu>
		</div>
	);
};

export default ShiftScheduleMenuList;
